var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.007,
    y: 7.78308,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8571 16.8832C27.1578 16.8832 20.1071 23.9339 20.1071 32.6332C20.1071 41.3324 27.1578 48.3832 35.8571 48.3832C44.5563 48.3832 51.6071 41.3324 51.6071 32.6332C51.6071 23.9339 44.5563 16.8832 35.8571 16.8832ZM43.6796 35.1007C42.9971 33.5782 40.4771 30.2182 36.8021 30.5857C32.9696 31.0057 28.6121 33.1582 27.3521 36.3082C25.4096 34.7857 27.0896 32.1607 28.2446 30.9532C27.9821 29.7982 28.7171 27.2782 29.1371 26.2282C29.2946 25.3357 30.0296 24.7057 30.3971 24.5482C30.3446 23.9182 31.4471 23.6032 31.9721 23.4982L32.0246 23.3932C32.1821 22.9207 32.3396 22.3432 33.7046 21.9232C34.8596 21.5032 35.9096 22.5532 36.3296 23.1307C36.4346 22.8157 36.8546 22.3432 37.2746 22.7107C41.0546 23.2882 42.3146 27.4357 42.5246 29.3782C43.2596 29.9032 44.7821 31.2682 45.1496 32.5282C45.5171 34.0507 45.0971 34.3657 44.5721 34.7857L44.4671 34.8907C44.2046 35.2057 43.8896 35.2057 43.6796 35.1007ZM42.9446 36.7282C42.1203 40.1827 39.3483 42.8339 35.8571 43.5007C33.6521 43.5007 30.1346 40.0357 29.1371 38.4082C27.0896 38.2507 27.5621 37.2007 28.0346 36.7282L27.7721 36.6232C28.7171 34.4182 31.3946 31.7932 36.6446 31.1632C39.5321 30.7957 41.7371 32.8432 43.0496 34.9432C43.1021 35.6257 43.0496 36.3607 42.9446 36.7282ZM31.4471 34.1032C31.7621 34.8907 32.7071 36.1507 34.0721 34.6807C33.9671 34.2607 33.2321 33.5257 31.4471 34.1032ZM33.5471 41.5582C33.3371 41.2432 34.5971 41.0857 35.2271 41.0332L36.0671 40.8232C36.2246 40.1407 35.9096 40.0882 35.7521 40.1407C34.4921 40.2457 34.5971 38.7757 34.9121 38.3032C35.2796 37.8832 36.0671 38.0407 36.3296 38.0932C36.5921 38.1982 37.0121 38.0932 37.1696 38.0407C37.9571 37.9882 37.9046 38.9332 37.7471 39.4057C37.6946 40.0357 36.8021 40.2457 36.3821 40.2457C36.3296 40.7182 36.4346 40.9282 36.5396 40.9282L38.3246 41.3482C39.0071 41.6107 38.6396 41.6632 38.3246 41.7157C37.4321 41.1382 36.8021 41.3482 36.3821 41.4532L36.0671 41.5582C35.3321 41.2957 34.5446 41.3482 34.2296 41.4532C34.0721 41.6107 33.7046 41.8207 33.5471 41.5582ZM38.2196 34.9432C38.2721 34.3132 38.9021 33.2632 40.7396 34.2082C40.4771 34.8382 39.5846 35.8357 38.2196 34.9432Z",
    fill: "#EFBFA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_380",
    x: 0.506958,
    y: 0.083081,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_380",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_380"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1071,
    y: 16.8832,
    width: 31.5,
    height: 31.5,
    rx: 15.75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWif);
export default __webpack_public_path__ + "static/media/wif.a0d476f1b2d2ef85c5dfa822df1c4700.svg";
export { ForwardRef as ReactComponent };